import CoreFactory, { Glue42Core } from "@glue42/core";
import { Glue42Office } from "../glue4office";
import word from "./word/main";
import excel from "./excel/main";
import outlook from "./outlook/main";

import prepareConfig from "./config";
import { version } from "./version";

export default (options: Glue42Office.Config): Promise<Glue42Office.Glue4Office> => {

    // get config object
    // basically selecting some properties (and defaulting them)
    // it's used to extract things like layouts, appManager, activities etc things
    // that glueCore itself doesn't know about
    options = options || {};
    const glueConfig = prepareConfig(options);

    function createOutlook(core: Glue42Core.GlueCore) {
        if (glueConfig.outlook) {
            return outlook({ agm: core.agm });
        }
    }

    function createExcel(core: Glue42Core.GlueCore): Glue42Office.Excel.API {
        if (glueConfig.excel) {
            return excel({ agm: core.agm });
        }
    }

    function createWord(core: Glue42Core.GlueCore) {
        if (glueConfig.word) {
            return word({ agm: core.agm });
        }
    }

    const ext: Glue42Core.Extension = {
        // define extra libraries for glue-core to raise
        libs: [
            { name: "outlook", create: createOutlook },
            { name: "excel", create: createExcel },
            { name: "word", create: createWord },
        ],

        version,

        enrichGlue: (glue: Glue42Core.GlueCore) => {
            // put some data to config
            glue.config.outlook = glueConfig.outlook;
            glue.config.excel = glueConfig.excel;
            glue.config.word = glueConfig.word;
        },
    };

    function extendExistingGlue(glue: any) {
        glue.outlook = createOutlook(glue);
        glue.excel = createExcel(glue);
        glue.word = createWord(glue);

        ext.enrichGlue(glue);
    }

    // users can pass existing glue object (that can be glue-core or glue)
    // in that case it will be extended with office libs
    if (options.glue) {
        extendExistingGlue(options.glue);
        return Promise.resolve(options.glue);
    }

    return CoreFactory(options, ext) as any as Promise<Glue42Office.Glue4Office>;
};
